import React, { useState, useEffect } from 'react';
import { Button, Form, Input, Select, Switch, Spin, Row, Col, Icon } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import moment from 'moment';
import * as actions from '../../actions';
import InputMask from 'react-input-mask';

const FormItem = Form.Item;
const { Option } = Select;

const AddPerson = (props) => {
    const [loading, setLoading] = useState(false);
    const [maskKey, setMaskKey] = useState(Date.now());

    const { getCouncilNumbers } = props;

    useEffect(() => {
        if (!getCouncilNumbers || getCouncilNumbers.length === 0) {
            props.actions.getallcouncils();
        }
    }, []);

    const handleSubmit = () => {
        props.form.validateFields((err, values) => {
            if (!err) {
                const noMiddleName = !values.middleName || values.middleName.trim() === '';

                const payload = {
                    councilNumber: values.councilNumber,
                    firstName: values.firstName,
                    middleName: noMiddleName ? '' : values.middleName,
                    noMiddleName: noMiddleName,
                    lastName: values.lastName,
                    gender: values.gender,
                    dateOfBirth: moment(values.dateOfBirth, 'MM/DD/YYYY').format('YYYY-MM-DD'),
                    isUSCitizen: values.isUSCitizen
                };

                setLoading(true);

                props.actions.addPerson(payload)
                    .then((res) => {
                        setLoading(false);

                        if (res && res.personGuid) {
                            props.actions.getAlumniInfo(res.personGuid, 'admin');
                        }

                        props.form.resetFields();
                        setMaskKey(Date.now());
                    })
                    .catch(() => {
                        setLoading(false);
                    });
            }
        });
    };

    const { getFieldDecorator } = props.form;
    const inputStyle = { borderRadius: 8, height: 38 };

    return (
        <div
            className='new-person-div'
            style={{
                background: "#fff",
                borderRadius: 14,
                padding: 0,
                boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
                overflow: "hidden"
            }}
        >
            <div
                style={{
                    // background: "linear-gradient(90deg, #004aad, #007bff)",
                    padding: "16px 22px",
                    // color: "#004aad",
                    // fontSize: 18,
                    // fontWeight: "600",
                    // letterSpacing: 0.5,
                    // textAlign: 'center'
                }}
            >
                {/* <span><Icon type="user-add" style={{ fontSize: '22px' }} /> Add New Person</span> */}
            </div>

            <div style={{ padding: 25 }}>
                <Spin spinning={loading} size="large">
                    <Form layout="vertical">

                        <Row gutter={16}>
                            <Col span={8}>
                                <FormItem label="First Name">
                                    {getFieldDecorator('firstName', {
                                        rules: [{ required: true, message: 'Please enter first name' }]
                                    })(<Input style={inputStyle} placeholder="Enter first name" />)}
                                </FormItem>
                            </Col>

                            <Col span={8}>
                                <FormItem label="Middle Name">
                                    {getFieldDecorator('middleName')(
                                        <Input style={inputStyle} placeholder="Enter middle name" />
                                    )}
                                </FormItem>
                            </Col>

                            <Col span={8}>
                                <FormItem label="Last Name">
                                    {getFieldDecorator('lastName', {
                                        rules: [{ required: true, message: 'Please enter last name' }]
                                    })(<Input style={inputStyle} placeholder="Enter last name" />)}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <FormItem label="Date of Birth">
                                    {getFieldDecorator('dateOfBirth', {
                                        rules: [
                                            { required: true, message: 'Please enter date of birth' },
                                            {
                                                pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(19|20)\d{2}$/,
                                                message: 'Correct format MM/DD/YYYY',
                                            },
                                        ],
                                    })(
                                        <InputMask
                                            key={maskKey}
                                            mask="99/99/9999"
                                            placeholder="MM/DD/YYYY"
                                            className="ant-input"
                                            render={(ref, inputProps) => (
                                                <Input {...inputProps} ref={ref} style={inputStyle} />
                                            )}
                                        />
                                    )}
                                </FormItem>
                            </Col>

                            <Col span={8}>
                                <FormItem label="Gender">
                                    {getFieldDecorator('gender', {
                                        rules: [{ required: true, message: 'Please select gender' }]
                                    })(
                                        <Select placeholder="Select gender" style={inputStyle}>
                                            <Option value="M">Male</Option>
                                            <Option value="F">Female</Option>
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>

                            <Col span={8}>
                                <FormItem label="Council Number">
                                    {getFieldDecorator('councilNumber', {
                                        rules: [{ required: true, message: 'Please select council' }]
                                    })(
                                        <Select
                                            placeholder="Select Council"
                                            style={inputStyle}
                                            showSearch
                                            optionFilterProp="children"
                                        >
                                            {props.getCouncilNumbers && props.getCouncilNumbers.map((council) => (
                                                <Option key={council.sKCouncilId} value={council.councilNumber}>
                                                    {council.councilLong}
                                                </Option>
                                            ))}
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={8}>
                                <FormItem label="U.S. Citizen">
                                    {getFieldDecorator('isUSCitizen', {
                                        initialValue: true,
                                        valuePropName: 'checked'
                                    })(
                                        <Switch checkedChildren="Yes" unCheckedChildren="No" />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <div
                            style={{
                                margin: "25px 0 20px",
                                height: 1,
                                background: "#e6e6e6"
                            }}
                        ></div>

                        <Row>
                            <Col span={24} style={{ textAlign: "right" }}>
                                <Button
                                    onClick={() => { props.form.resetFields(); setMaskKey(Date.now()); }}
                                    style={{
                                        borderRadius: 6,
                                        padding: "0 30px",
                                        height: 38,
                                        marginRight: 10
                                    }}
                                >
                                    Clear
                                </Button>

                                <Button
                                    type="primary"
                                    onClick={handleSubmit}
                                    style={{
                                        borderRadius: 6,
                                        padding: "0 40px",
                                        height: 38
                                    }}
                                    loading={loading}
                                >
                                    Submit
                                </Button>
                            </Col>
                        </Row>

                    </Form>
                </Spin>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        getCouncilNumbers: state.councilsreducer.councils
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) };
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Form.create()(AddPerson));



// WEBPACK FOOTER //
// ./src/components/RecordRepair/AddPerson.js